import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { orderService } from '../services/api';
import { FaCheckCircle, FaShoppingBag, FaHome } from 'react-icons/fa';

const OrderSuccessPage = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        setLoading(true);
        const response = await orderService.getOrderById(id);
        setOrder(response.data);
      } catch (error) {
        console.error('Error fetching order:', error);
        setError('Failed to load order details. Please check your order history.');
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [id]);

  if (loading) {
    return (
      <div className="container py-4 text-center">
        <p>Loading order details...</p>
      </div>
    );
  }

  if (error || !order) {
    return (
      <div className="container py-4">
        <div className="alert alert-error text-center">
          <p>{error || 'Order not found'}</p>
          <Link to="/orders" className="btn btn-primary mt-4">
            View Your Orders
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-4">
      <div className="card max-w-3xl mx-auto text-center p-8">
        <div className="text-success-color mb-4" style={{ fontSize: '5rem' }}>
          <FaCheckCircle style={{ margin: '0 auto' }} />
        </div>
        
        <h1 className="text-3xl font-bold mb-2">Order Confirmed!</h1>
        
        <p className="mb-4">
          Thank you for your purchase. Your order has been received and is being processed.
        </p>
        
        <div className="mb-6">
          <div className="bg-light-gray p-4 rounded mb-4">
            <p className="text-xl font-medium">Order #{order.order.id}</p>
            <p className="text-sm">Date: {new Date(order.order.created_at).toLocaleDateString()}</p>
            <p className="text-primary-color font-bold mt-2">
              Total: ${parseFloat(order.order.total_amount).toFixed(2)}
            </p>
          </div>
          
          <h2 className="text-xl font-bold mb-2">Order Details</h2>
          
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-light-gray">
                  <th className="text-left py-2">Product</th>
                  <th className="text-center py-2">Quantity</th>
                  <th className="text-right py-2">Price</th>
                </tr>
              </thead>
              <tbody>
                {order.items.map((item) => (
                  <tr key={item.id} className="border-b border-light-gray">
                    <td className="text-left py-2">{item.name}</td>
                    <td className="text-center py-2">{item.quantity}</td>
                    <td className="text-right py-2">${parseFloat(item.price * item.quantity).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          <div className="mt-4 text-left">
            <p className="font-medium">Shipping Address:</p>
            <p className="text-sm">{order.order.shipping_address}</p>
          </div>
        </div>
        
        <div className="flex flex-col md:flex-row justify-center gap-4">
          <Link to="/" className="btn btn-secondary flex items-center justify-center gap-2">
            <FaHome /> Continue Shopping
          </Link>
          <Link to="/orders" className="btn btn-primary flex items-center justify-center gap-2">
            <FaShoppingBag /> View My Orders
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccessPage; 